import { Div, Icon, Label, Touchable } from "@grassrootly/rn-core";
import { DrawerContentComponentProps } from "@react-navigation/drawer";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSideNav } from "./useSideNav";
import { Platform } from "react-native";

export default function SideNav({ navigation }: DrawerContentComponentProps) {
  const insets = useSafeAreaInsets();
  const { logOut } = useSideNav();
  const goHome = () => navigation.jumpTo("home");
  const goToMyGames = () => navigation.jumpTo("my-games");
  const goToStats = () => navigation.jumpTo("stats");
  return (
    <Div classNames={["bgSecondaryMain", "flex1"]}>
      <Div
        classNames={["flex1", `pt-{${insets.top + 4 + (Platform.OS == "web" ? 16 : 0)}}`, `pb-{${insets.bottom + 8}}`]}
      >
        <Icon name="arrow_back_ios" size={24} onPress={navigation.toggleDrawer} classNames={["ml-{auto}", "mr-{15}"]} />
        <Div classNames={["m-{20}", "flex1"]}>
          <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goHome}>
            <Icon name="calendar_month" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">Featured Game</Label>
          </Touchable>

          <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goToMyGames}>
            <Icon name="sports_soccer" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">My Games</Label>
          </Touchable>

          <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goToStats}>
            <Icon name="analytics" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">Monthly Rankings</Label>
          </Touchable>

          <Touchable classNames={["flexRow", "mb-{10}", "mt-{auto}", "alignItemsCenter"]} onPress={logOut}>
            <Icon name="logout" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">Log out</Label>
          </Touchable>
        </Div>
      </Div>
    </Div>
  );
}
